import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { fetchComRetentativa } from './sessao';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

// Configuração padrão de sessão (localStorage, persistSession, autoRefreshToken).
// O fetch renova e repete uma vez em erro de token; nunca encerra a sessão.
export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  global: {
    fetch: fetchComRetentativa,
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});